import { render, staticRenderFns } from "./SceneView.vue?vue&type=template&id=b06b2c0e&scoped=true&"
import script from "./SceneView.vue?vue&type=script&lang=js&"
export * from "./SceneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b2c0e",
  null
  
)

export default component.exports